const translations = {
    errorMessage: `{{characterCount}} / {{characterLimit}}`
};

export default translations;
